import {getGuildId} from '../../../models/Notification'
import {Button} from '@mui/material'
import {ROUTES} from '../../../../constants/routing'
import {generatePath, useNavigate} from 'react-router-dom'
import NotificationDisplay from './GenericNotificationDisplay'
import {NotificationDTO} from '../../../../generated/api'

const ServiceRequestQuotationDeliveredNotification = ({notification}: { notification: NotificationDTO }) => {
    const navigate = useNavigate()
    const guildId = getGuildId(notification)
    return (
        <NotificationDisplay
            notification={notification}
            title="Quotation Received"
            canClose={true}
        >
            <Button
                id="notification-action-button-accept"
                type="button"
                variant="contained"
                onClick={() => navigate(generatePath(ROUTES.approvalDashboard.path || '', {currentGuildId: guildId}))}
            >
                View
            </Button>
        </NotificationDisplay>

    )

}



export default ServiceRequestQuotationDeliveredNotification
